// DatalakeStatus — chip pequeno que mostra "Datalake Voalle: há N min".
// Auto-refresh interno de 30s. Cor varia conforme lag.
import { useEffect, useState } from 'react';
import { syncStatus } from '../lib/api.js';

export default function DatalakeStatus({ compacto = false }) {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let alive = true;
    async function carregar() {
      try {
        const r = await syncStatus.get();
        if (alive) setInfo(r);
      } catch {}
    }
    carregar();
    const h = setInterval(carregar, 30_000);
    return () => { alive = false; clearInterval(h); };
  }, []);

  if (!info || info.lag_min == null) return null;
  const lag = info.lag_min;
  const cor = lag > 15 ? '#dc2626' : lag > 10 ? '#d97706' : '#6b7280';
  const bg  = lag > 15 ? '#fee2e2' : lag > 10 ? '#fef3c7' : '#f3f4f6';

  return (
    <div
      title={`Última sync: ${info.ultima_sync_at ? new Date(info.ultima_sync_at).toLocaleString('pt-BR') : '—'} (${info.total_visitas_hoje} OS hoje)`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: compacto ? '2px 8px' : '4px 10px',
        background: bg,
        color: cor,
        borderRadius: 999,
        fontSize: compacto ? 11 : 12,
        fontWeight: 500,
      }}
    >
      <span style={{
        width: 7, height: 7, borderRadius: '50%', background: cor,
        animation: lag > 15 ? 'hb-pulse 1.5s infinite' : 'none',
      }}/>
      Datalake Voalle: {lag === 0 ? 'agora' : `há ${lag}min`}
    </div>
  );
}
